import axios from '@/resources/libs/axios'

export default {
    list() {
        return axios.get(`/gei/auxiliaries/order-maintenance-subtypes/list/all`)
    },
}